import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  DateField,
  ArrayField,
  Datagrid,
  TopToolbar,
  EditButton,
  DeleteButton,
} from 'react-admin';

const FinancingShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton mutationMode="pessimistic" />
  </TopToolbar>
);

export const FinancingShow = () => (
  <Show title="Финансирование" actions={<FinancingShowActions />}>
    <SimpleShowLayout>
      <TextField source="subtitle" label="Подзаголовок" />
      <TextField source="description" label="Описание" />
      <BooleanField source="isActive" label="Активно" />
      <DateField source="createdAt" label="Создано" showTime />
      <DateField source="updatedAt" label="Обновлено" showTime />
      
      <ArrayField source="items" label="Элементы финансирования">
        <Datagrid bulkActionButtons={false}>
          <TextField source="title" label="Заголовок" />
          <TextField source="description" label="Описание" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
